import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-top"
// Attach to the scroll-to-top button (#myBtn)
export default class extends Controller {
  connect() {
    this.boundScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.boundScroll)
  }

  disconnect() {
    window.removeEventListener('scroll', this.boundScroll)
  }

  onScroll() {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      this.element.style.display = 'block'
    } else {
      this.element.style.display = 'none'
    }
  }

  scrollToTop() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
}
